const CommonLoader = () => {
  return (
    <div className="flex items-center justify-center fixed bg-[rgba(0,0,0,0.31)] inset-0 z-[99999]">
      <div className="w-10 h-10 border-4 border-gray-200 border-t-[var(--primary-color)] rounded-full animate-spin"></div>
    </div>
  );
};

export default CommonLoader;
